/**
 * Permission code constants
 * These must match the backend permission codes exactly
 * Only used for TypeScript type safety and code completion
 */

export const PERMISSION_CODES = {
  // Finance
  FINANCE_OVERVIEW_VIEW: 'finance:overview_view',
  FINANCE_SETUP_VIEW: 'finance:setup_view',
  FINANCE_SETUP_MANAGE: 'finance:setup_manage',
  FINANCE_BANK_SYNC_VIEW: 'finance:bank_sync_view',
  FINANCE_AUDIT_VIEW: 'finance:audit_view',
  FINANCE_BANK_ACCOUNTS_VIEW: 'finance:bank_accounts_view',
  FINANCE_BANK_TRANSACTIONS_VIEW: 'finance:bank_transactions_view',
  FINANCE_BANK_TRANSACTIONS_EXPORT: 'finance:bank_transactions_export',
  FINANCE_COA_VIEW: 'finance:coa_view',
  FINANCE_COA_MANAGE: 'finance:coa_manage',
  FINANCE_RECONCILIATION_VIEW: 'finance:reconciliation_view',
  FINANCE_RECONCILIATION_APPLY: 'finance:reconciliation_apply',
  FINANCE_RECONCILIATION_REVERSE: 'finance:reconciliation_reverse',
  FINANCE_JOURNAL_VIEW: 'finance:journals_view',
  FINANCE_JOURNAL_CREATE: 'finance:journal_create',
  FINANCE_JOURNAL_APPROVE: 'finance:journal_approve',
  FINANCE_JOURNAL_POST: 'finance:journal_post',
  FINANCE_JOURNAL_REVERSE: 'finance:journal_reverse',
  FINANCE_REPORTS_VIEW: 'finance:reports_view',
  FINANCE_REPORTS_EXPORT: 'finance:reports_export',

  // Product
  PRODUCT_VIEW: 'product:view',
  PRODUCT_DESCRIPTION_MANAGE_VIEW: 'product:description_manage_view',
  PRODUCT_DESCRIPTION_MANAGE_EDIT: 'product:description_manage_edit',
  PRODUCT_VIEW_COST: 'product:view_cost',
  PRODUCT_VIEW_SUPPLIERS: 'product:view_suppliers',
  PRODUCT_CREATE_EDIT: 'product:create_edit',
  PRODUCT_EDIT_COST: 'product:edit_cost',
  PRODUCT_EDIT_PRICE: 'product:edit_price',
  PRODUCT_EXPORT: 'product:export',
  PRODUCT_DELETE: 'product:delete',
  PRODUCT_DISPLAYS_VIEW: 'product_displays:view',
  PRODUCT_DISPLAYS_EDIT: 'product_displays:edit',
  PRODUCT_CHANGE_LOG_VIEW: 'product:change_log_view',
  SHIPMENT_SPEC_VIEW: 'shipment_spec:view',
  NO_BARCODE_PRODUCT_VIEW: 'no_barcode_product:view',
  NO_BARCODE_PRODUCT_MANAGE: 'no_barcode_product:manage',
  EXPIRED_PRODUCT_MANAGEMENT_VIEW: 'expired_product_management:view',
  UNSALABLE_PRODUCT_REPORT_VIEW: 'expired_product_management:unsalable_report_view',
  UNSALABLE_PRODUCT_REPORT_CREATE: 'expired_product_management:unsalable_report_create',
  UNSALABLE_PRODUCT_REPORT_FOLLOW_UP: 'expired_product_management:unsalable_report_follow_up',
  NEW_ARRIVAL_MANAGEMENT_VIEW: 'new_arrival_management:view',
  ONLINE_PRODUCT_VIEW: 'online_product:view',
  ONLINE_PRODUCT_CREATE: 'online_product:create',
  ONLINE_PRODUCT_APPROVE: 'online_product:approve',
  ONLINE_ORDER_FOLLOWUP_VIEW: 'online_order_followup:view',
  ONLINE_STORE_DISCOUNT_CODE_VIEW: 'online_store_discount_code:view',
  ONLINE_STORE_CUSTOMER_MESSAGE_VIEW: 'online_store_customer_message:view',
  ONLINE_STORE_CUSTOMER_MESSAGE_EDIT: 'online_store_customer_message:edit',
  ONLINE_STORE_EMAIL_NOTIFICATION_VIEW: 'online_store_email_notification:view',
  ONLINE_STORE_BLOG_POST_VIEW: 'online_store_blog_post:view',
  ONLINE_STORE_BLOG_POST_CREATE_EDIT: 'online_store_blog_post:create_edit',
  ONLINE_STORE_BLOG_POST_DELETE: 'online_store_blog_post:delete',
  MARKETING_MANAGEMENT_VIEW: 'marketing_management:view',
  MARKETING_MANAGEMENT_MANAGE: 'marketing_management:manage',

  // Product Collection

  // Discount
  DISCOUNT_VIEW: 'discount:view',
  DISCOUNT_CREATE_EDIT: 'discount:create_edit',
  DISCOUNT_DELETE: 'discount:delete',

  // Traffic Product Management (removed; merged into Supply Product Management)

  // Supply Product Management
  SUPPLY_PRODUCT_VIEW: 'supply_product:view',

  // Featured Product Management
  FEATURED_PRODUCT_VIEW: 'featured_product:view',

  // Banned Product Management
  BANNED_PRODUCTS_VIEW: 'banned_products:view',
  BANNED_PRODUCTS_EDIT: 'banned_products:edit',

  // Replenishment Management
  REPLENISHMENT_VIEW: 'replenishment:view',

  // Procurement Analysis
  PROCUREMENT_ANALYSIS: 'procurement_analysis',
  PROCUREMENT_ANALYSIS_MODULE_VIEW: 'procurement_analysis:module_view',
  PROCUREMENT_ANALYSIS_MODULE_EXPORT: 'procurement_analy:module_export',
  PROCUREMENT_ANALYSIS_OPPORTUNITY_VIEW: 'procurement_analysis:opportunity_view',
  PROCUREMENT_ANALYSIS_DASHBOARD_VIEW: 'procurement_analysis:dashboard_view',
  PROCUREMENT_ANALYSIS_DATA_ERRORS_VIEW: 'procurement_analysis:data_errors_view',
  PROCUREMENT_ANALYSIS_HISTORY_PERFORMANCE_VIEW: 'procurement_analysis:history_performance_view',
  PROCUREMENT_ANALYSIS_SMALL_TRIAL_SALE_FOLLOWUP_VIEW:
    'procurement_analysis:small_trial_sale_followup_view',

  // Order
  ORDER_VIEW: 'order:view',
  ORDER_EXPORT: 'order:export',
  ORDER_REFUND: 'order:refund',
  ORDER_PAYMENT_METHOD_EDIT: 'order:payment_method_edit',
  ORDER_RECONCILIATION_VIEW: 'order:reconciliation_view',
  ONLINE_ORDER_VIEW: 'order:online_view',
  ONLINE_ORDER_EDIT: 'order:online_edit',
  ONLINE_ORDER_CASH_REFUND: 'order:online_refund_cash',
  ONLINE_ORDER_ORIGINAL_REFUND: 'order:online_refund_original',
  WHOLESALE_ORDER_VIEW: 'order:wholesale_view',
  WHOLESALE_ORDER_CREATE: 'order:wholesale_create',

  // Purchase
  PURCHASE_OPPORTUNITY_VIEW: 'purchase:opportunity_view',
  PURCHASE_OPPORTUNITY_CREATE_EDIT: 'purchase:opportunity_create_edit',
  PURCHASE_OPPORTUNITY_ASSIGN: 'purchase:opportunity_assign',
  PURCHASE_PROCUREMENT_GOAL_VIEW: 'purchase:procurement_goal_view',
  PURCHASE_PROCUREMENT_GOAL_CREATE_EDIT: 'purchase:procurement_goal_create_edit',
  PURCHASE_PROCUREMENT_GOAL_FOLLOW: 'purchase:procurement_goal_follow',
  PURCHASE_PROCUREMENT_GOAL_COMPLETE: 'purchase:procurement_goal_complete',
  PURCHASE_OPPORTUNITY_DELETE: 'purchase:opportunity_delete',
  PURCHASE_OPPORTUNITY_CANNOT_CONTACT_REVIEW: 'purchase:opportunity_review_cannot_contact',
  PURCHASE_QUOTE_VIEW: 'purchase:quote_view',
  PURCHASE_QUOTE_CREATE_EDIT: 'purchase:quote_create_edit',
  PURCHASE_QUOTE_DELETE: 'purchase:quote_delete',
  PURCHASE_QUOTE_APPROVE: 'purchase:quote_approve',
  AI_PURCHASE_IMPORT_VIEW: 'purchase:ai_import_view',
  AI_PURCHASE_IMPORT_CREATE_EDIT: 'purchase:ai_import_create_edit',
  PURCHASE_ORDER_VIEW: 'purchase:order_view',
  PURCHASE_MARKET_PRICE_SEARCH_VIEW: 'purchase:market_price_search_view',
  PURCHASE_GREENPRICE_CATALOG_VIEW: 'purchase:greenprice_catalog_view',
  PURCHASE_PRICE_COMPETITIVENESS_VIEW: 'purchase:price_competitiveness_view',
  PURCHASE_ORDER_ARRIVAL_SCHEDULE_VIEW: 'purchase:order_arrival_schedule_view',
  PURCHASE_ORDER_ARRIVAL_SCHEDULE_EDIT: 'purchase:order_arrival_schedule_edit',
  PURCHASE_ORDER_ARRIVAL_SCHEDULE_FINANCE_RECONCILIATION:
    'purchase:order_arrival_schedule_finance_reconciliation',
  PURCHASE_CATEGORY_ARRIVAL_CALENDAR_VIEW: 'purchase:category_arrival_calendar_view',
  PURCHASE_ORDER_CREATE_EDIT: 'purchase:order_create_edit',
  PURCHASE_ORDER_MERGE: 'purchase:order_merge',
  PURCHASE_ORDER_DELETE: 'purchase:order_delete',
  PURCHASE_ORDER_REQUEST_PAYMENT: 'purchase:order_request_payment',
  PURCHASE_ORDER_REQUEST_MODIFY: 'purchase:order_request_modify',
  PURCHASE_ORDER_MODIFY_APPROVAL_VIEW: 'purchase:order_modify_approval_view',
  PURCHASE_ORDER_MODIFY_APPROVE: 'purchase:order_modify_approve',
  PURCHASE_ORDER_PAYMENT_VIEW: 'purchase:order_payment_view',
  PURCHASE_ORDER_PAYMENT_VOUCHER_VIEW: 'purchase:order_payment_voucher_view',
  PURCHASE_ORDER_FINANCE_MANAGEMENT_VIEW: 'purchase:order_finance_management_view',
  PURCHASE_ORDER_PAYMENT_VARIANCE_REVIEW_VIEW: 'purchase:order_payment_variance_review_view',
  PURCHASE_ORDER_PAYMENT_EXECUTE: 'purchase:order_payment_execute',
  PURCHASE_ORDER_HANDLING_FOLLOWUP_VIEW: 'purchase:order_handling_followup_view',
  LOGISTICS_FEE_MANAGEMENT_VIEW: 'purchase:order_logistics_view',
  LOGISTICS_FEE_APPROVE_PAYMENT: 'purchase:order_logistics_approve_payment',
  EMPLOYEE_PURCHASE_REFUND_VIEW: 'purchase:employee_purchase_refund_view',
  EMPLOYEE_PURCHASE_REFUND_APPROVE: 'purchase:employee_purchase_refund_approve',

  // Supplier
  SUPPLIER_VIEW: 'supplier:view',
  SUPPLIER_CREATE_EDIT: 'supplier:create_edit',
  SUPPLIER_DELETE: 'supplier:delete',
  SUPPLIER_PLATFORM_GROUP_VIEW: 'supplier_platform_group:view',
  SUPPLIER_PLATFORM_GROUP_MATCH: 'supplier_platform_group:match',
  SUPPLIER_PLATFORM_MESSAGE_VIEW: 'supplier_platform_message:view',
  SUPPLIER_PLATFORM_MESSAGE_FOLLOW_UP: 'supplier_platform_message:follow_up',
  SUPPLIER_FOLLOW_UP_VIEW: 'supplier_follow_up:view',
  SUPPLIER_FOLLOW_UP_MANAGE: 'supplier_follow_up:manage',
  SUPPLIER_DEVELOPMENT_VIEW: 'supplier_development:view',
  SUPPLIER_DEVELOPMENT_CREATE_EDIT: 'supplier_development:create_edit',
  SUPPLIER_DEVELOPMENT_LINK_CONVERT: 'supplier_development:link_convert',
  SUPPLIER_CALLS_VIEW: 'supplier_calls:view',
  SUPPLIER_CALLS_CREATE: 'supplier_calls:create',
  SUPPLIER_CALLS_UPDATE_NOTES: 'supplier_calls:update_notes',
  SUPPLIER_CALLS_LISTEN_RECORDING: 'supplier_calls:listen_recording',

  // Brand
  BRAND_VIEW: 'brand:view',
  BRAND_CREATE_EDIT: 'brand:create_edit',
  BRAND_DELETE: 'brand:delete',

  // Category
  CATEGORY_VIEW: 'category:view',
  CATEGORY_EDIT: 'category:edit',
  CATEGORY_EXPORT: 'export:category',
  MANAGE_WAREHOUSE_SKU_LIMITS: 'manage_warehouse_sku_limits',
  CATEGORY_REVIEW_VIEW: 'category_review:view',
  CATEGORY_REVIEW_EDIT: 'category_review:edit',

  // Store
  STORE_VIEW: 'store:view',
  STORE_CREATE_EDIT: 'store:create_edit',
  STORE_DELETE: 'store:delete',
  STORE_RENT_VIEW: 'store_rent:view',
  STORE_RENT_MANAGE: 'store_rent:manage',
  STORE_RENT_PAYMENT_REQUEST: 'store_rent:payment_request',
  STORE_RENT_PAYMENT_EXECUTE: 'store_rent:payment_execute',
  // Store Targets
  STORE_TARGETS_VIEW: 'store_targets:view',
  STORE_TARGETS_EDIT: 'store_targets:edit',
  // Category Placement (Store-level first-level category planning)
  CATEGORY_PLACEMENT_VIEW: 'category_placement:view',
  CATEGORY_PLACEMENT_CREATE_EDIT: 'category_placement:create_edit',
  CATEGORY_PLACEMENT_APPROVE: 'category_placement:approve',

  // Roaster Records
  ROASTER_RECORD_VIEW: 'roaster_records:view',
  ROASTER_RECORD_EXPORT: 'roaster_records:export',

  // Store Tutorials
  STORE_TUTORIAL_VIEW: 'store_tutorials:view',
  STORE_TUTORIAL_CREATE_EDIT: 'store_tutorials:create_edit',
  STORE_TUTORIAL_DELETE: 'store_tutorials:delete',

  // Store Support Contacts
  STORE_SUPPORT_CONTACTS_VIEW: 'store_support_contacts:view',
  STORE_SUPPORT_CONTACTS_CREATE_EDIT: 'store_support_contacts:create_edit',
  STORE_SUPPORT_CONTACTS_DELETE: 'store_support_contacts:delete',
  STORE_INSPECTION_QUESTION_MANAGEMENT_VIEW: 'store_inspection_question_management:view',
  STORE_INSPECTION_QUESTION_MANAGEMENT_CREATE_EDIT:
    'store_inspection_question_management:create_edit',
  STORE_INSPECTION_REPORTS_VIEW: 'store_inspection_reports:view',
  STORE_INSPECTION_REPORTS_REVIEW: 'store_inspection_reports:review',
  STORE_BONUS_VIEW: 'store_bonus:view',
  STORE_BONUS_MANAGE: 'store_bonus:manage',
  STORE_BONUS_FINALIZE: 'store_bonus:finalize',
  PDA_DAILY_INVENTORY_CHECK_VIEW: 'pda_daily_inventory_check:view',
  PDA_DAILY_INVENTORY_CHECK_CREATE_EDIT: 'pda_daily_inventory_check:create_edit',
  PDA_DAILY_INVENTORY_CHECK_DELETE: 'pda_daily_inventory_check:delete',

  // Inventory
  INVENTORY_OVERVIEW_VIEW: 'inventory:overview_view',
  INVENTORY_ANOMALY_DASHBOARD_VIEW: 'inventory:anomaly_dashboard_view',
  INVENTORY_HISTORY_VIEW: 'inventory:history_view',
  INVENTORY_CHANGE_LOG_VIEW: 'inventory:change_log_view',
  INVENTORY_TASK_QUEUE_VIEW: 'inventory:task_queue_view',
  INVENTORY_CHECK_FOLLOWUPS_VIEW: 'inventory:inventory_check_followups_view',
  INVENTORY_LOSS_VIEW: 'inventory:loss_view',
  INVENTORY_FINANCIAL_LOSS_DASHBOARD_VIEW: 'inventory:financial_loss_dashboard_view',
  PRODUCT_DAMAGE_REPORT_VIEW: 'inventory:product_damage_report_view',
  PRODUCT_DAMAGE_REPORT_SYNC: 'inventory:product_damage_report_sync',
  INVENTORY_RECEIVE: 'purchase:order_receive',
  INVENTORY_REDUCE_RECEIVED_QUANTITY: 'purchase:order_reduce_received_quantity',
  WAREHOUSE_PURCHASE_RECEIPT_VIEW: 'warehouse_transfer:purchase_receipt_view',
  WAREHOUSE_PURCHASE_RECEIPT_CONFIRM: 'warehouse_transfer:purchase_receipt_confirm',
  INVENTORY_ADJUST: 'inventory:adjust',
  INVENTORY_EXPORT: 'inventory:export',
  STOCKTAKE_VIEW: 'stocktake:view',
  STOCKTAKE_CREATE_EDIT: 'stocktake:create_edit',
  STOCKTAKE_DELETE: 'stocktake:delete',
  WAREHOUSE_STRUCTURE_ANALYSIS_VIEW: 'warehouse_structure_analysis:view',
  STORE_STRUCTURE_ANALYSIS_VIEW: 'store_structure_analysis:view',
  INVENTORY_EXPIRY_ANALYSIS_VIEW: 'inventory_expiry_analysis:view',
  INVENTORY_STORE_ANALYSIS_VIEW: 'inventory_store_analysis:view',
  INVENTORY_TURNOVER_ANALYSIS_VIEW: 'inventory_turnover_analysis:view',
  // Inventory Analysis
  INVENTORY_UNSOLD_PRODUCTS_VIEW: 'inventory_unsold_products:view',
  INVENTORY_UNSOLD_PRODUCTS_EXPORT: 'inventory:unsold_products:export',

  // Script
  SCRIPT_VIEW: 'script:view',
  SCRIPT_EXECUTION_LOG_VIEW: 'script:execution_log_view',

  // Data Anomaly
  DATA_CHECKS_VIEW: 'data_anomaly:data_checks:view',
  DUPLICATE_BARCODE_VIEW: 'data_anomaly:duplicate_barcode_view',
  MISSING_CATEGORIES_VIEW: 'data_anomaly:missing_categories_view',
  CATEGORY_ERRORS_VIEW: 'data_anomaly:category_errors_view',
  MISSING_BRAND_VIEW: 'data_anomaly:missing_brand:view',
  MISSING_BRAND_UPDATE: 'data_anomaly:missing_brand:update',
  MISSING_DESCRIPTION_VIEW: 'data_anomaly:missing_description:view',
  MISSING_DESCRIPTION_UPDATE: 'data_anomaly:missing_description:update',
  BAD_PRODUCT_NAME_VIEW: 'data_anomaly:bad_name:view',
  BAD_PRODUCT_NAME_UPDATE: 'data_anomaly:bad_name:update',
  PRODUCT_EXPIRY_DATE_ERROR_VIEW: 'data_anomaly:product_expiry_date_error:view',
  PRODUCT_EXPIRY_DATE_ERROR_APPROVE: 'data_anomaly:product_expiry_date_error:approve',
  PRODUCT_STOCK_TYPE_MANAGEMENT: 'products:bulk_stock_type',
  // Data Anomaly - Duplicate Products Management
  DUPLICATE_PRODUCTS_MANAGE: 'data_anomaly:merge_products',

  // Sales Analysis
  DATA_DASHBOARD_VIEW: 'sales_analysis:data_dashboard_view',
  PRODUCT_SALES_ANALYSIS_VIEW: 'sales_analysis:product_sales_view',
  PRODUCT_SALES_ANALYSIS_EXPORT: 'sales_analysis:product_sales_export',
  PRODUCT_SPECIFIC_SALES_VIEW: 'sales_analysis:specific_product_sales_view',
  PRODUCT_SPECIFIC_SALES_ASSIGN: 'sales_analysis:specific_product_sales_assign',
  CATEGORY_SALES_VIEW: 'sales_analysis:category_sales_view',
  CATEGORY_SALES_CHART_VIEW: 'sales_analysis:category_sales_chart_view',
  CATEGORY_SALES_EXPORT: 'sales_analysis:category_sales_export',
  PAYMENT_GATEWAY_VIEW: 'sales_analysis:payment_gateway_view',
  SUPPLIER_SALES_REPORT_VIEW: 'sales_analysis:supplier_sales_report_view',
  SUPPLIER_SALES_REPORT_EXPORT: 'sales_analysis:supplier_sales_report_export',
  FRANCHISE_STORE_SALES_ANALYSIS_VIEW: 'sales_analysis:franchise_store_sales_analysis',
  ONLINE_STORE_BEHAVIOUR_VIEW: 'sales_analysis:online_store_behaviour_view',
  // Deprecated - kept for backward compatibility during migration
  GROSS_MARGIN_ANALYSIS_VIEW: 'sales_analysis:gross_margin_analysis_view',

  // POS System
  STORE_ACCOUNT_VIEW: 'pos_system:store_account_view',
  STORE_ACCOUNT_CREATE_EDIT: 'pos_system:store_account_create_edit',
  STORE_ACCOUNT_DELETE: 'pos_system:store_account_delete',
  PDA_OPERATION_LOG_VIEW: "store:pda_operation_log_view",
  PDA_ACCOUNT_VIEW: 'pos_system:pda_account_view',
  PDA_ACCOUNT_CREATE_EDIT: 'pos_system:pda_account_create_edit',
  PDA_ACCOUNT_DELETE: 'pos_system:pda_account_delete',
  PAYMENT_METHOD_VIEW: 'pos_system:payment_method_view',
  POS_APP_VERSION_VIEW: 'pos_system:app_version_view',
  POS_APP_VERSION_CREATE_EDIT: 'pos_system:app_version_create_edit',
  POS_APP_VERSION_DELETE: 'pos_system:app_version_delete',
  POS_SESSION_VIEW: 'pos_system:session_view',
  POS_OPERATION_LOG_VIEW: 'pos_system:operation_log_view',
  POS_RECEIPT_CONTENT_VIEW: 'pos_system:receipt_content_view',
  POS_QUICK_ACTION_VIEW: 'pos_system:quick_action_view',
  POS_BEA_CONFIG_VIEW: 'pos_system:bea_config_view',
  POS_BEA_CONFIG_EDIT: 'pos_system:bea_config_edit',

  // Market Info
  COLLECTION_TASK_VIEW: 'market_info:collection_task_view',
  COLLECTION_TASK_CREATE_EDIT: 'market_info:collection_task_create_edit',
  COLLECTION_TASK_DELETE: 'market_info:collection_task_delete',
  MI_PRODUCT_VIEW: 'market_info:mi_product_view',
  MI_PRODUCT_EDIT: 'market_info:mi_product_edit',
  MI_PRODUCT_DELETE: 'market_info:mi_product_delete',
  DATA_REVIEW_VIEW: 'market_info:data_review_view',
  DATA_REVIEW_EDIT_APPROVE: 'market_info:data_review_edit_approve',
  DATA_ANALYSIS_VIEW: 'market_info:data_analysis_view',
  PRICE_ANALYSIS_VIEW: 'market_info:price_analysis_view',
  MARKET_PRODUCT_ANALYSIS_VIEW: 'market_info:market_product_analysis_view',
  MI_USER_VIEW: 'market_info:mi_user_view',
  MI_USER_CREATE_EDIT: 'market_info:mi_user_create_edit',
  MI_USER_DELETE: 'market_info:mi_user_delete',
  CONVERT_TO_OPPORTUNITY: 'market_info:convert_to_opportunity',

  // Warehouse Transfer
  WAREHOUSE_DASHBOARD_VIEW: 'warehouse_transfer:warehouse_dashboard_view',
  TRANSFER_ORDER_VIEW: 'warehouse_transfer:transfer_order_view',
  PDA_SHIPPING_LOG_VIEW: 'warehouse_transfer:pda_operation_log_view',
  TRANSFER_EXCEPTION_FOLLOWUP_VIEW: 'warehouse_transfer:exception_followup_view',
  TRANSFER_EXCEPTION_FOLLOWUP_EDIT: 'warehouse_transfer:exception_followup_edit',
  TRANSFER_PICKING_PROGRESS_VIEW: 'warehouse_transfer:picking_progress_view',
  TRANSFER_ORDER_CREATE_EDIT: 'warehouse_transfer:transfer_order_create_edit',
  TRANSFER_ORDER_SUBMIT_TO_PICKING: 'warehouse_transfer:transfer_order_submit_to_picking',
  TRANSFER_ORDER_DELETE: 'warehouse_transfer:transfer_order_delete',
  TRANSFER_ORDER_MANUAL_RECEIVING: 'warehouse_transfer:transfer_order_manual_receiving',
  TRANSFER_SHIPPING_SCHEDULE_VIEW: 'warehouse_transfer:shipping_schedule_view',
  TRANSFER_SHIPPING_SCHEDULE_CREATE_EDIT: 'warehouse_transfer:shipping_schedule_create_edit',
  WAREHOUSE_PURCHASE_ORDER_ARRIVAL_SCHEDULE_VIEW:
    'warehouse_transfer:purchase_order_arrival_schedule_view',
  INSPECTION_RECORD_VIEW: 'warehouse_transfer:inspection_record_view',
  INSPECTION_RECORD_CREATE_EDIT: 'warehouse_transfer:inspection_record_create_edit',
  INSPECTION_RECORD_APPROVE: 'warehouse_transfer:inspection_record_approve',
  STORE_RETURN_VIEW: 'warehouse_transfer:store_return_view',
  STORE_RETURN_APPROVE: 'warehouse_transfer:store_return_approve',
  PRODUCT_TRANSFER_RECORD_VIEW: 'warehouse_transfer:product_transfer_record_view',
  TRANSFER_PRODUCT_SEARCH_VIEW: 'warehouse_transfer:transfer_product_search_view',

  // Price Change Management (Operations Management)
  PRICE_CHANGE_VIEW: 'price_change:view',
  PRICE_CHANGE_APPROVE: 'price_change:approve',
  PRICE_CHANGE_EXPORT: 'price_change:export',

  // Hanshow electronic shelf labels
  HANSHOW_ESL_VIEW: 'hanshow_esl:view',
  HANSHOW_ESL_MANAGE: 'hanshow_esl:manage',

  // User Management
  USER_VIEW: 'user_management:user_view',
  USER_CREATE_EDIT: 'user_management:user_create_edit',
  USER_DELETE: 'user_management:user_delete',
  TEAM_VIEW: 'user_management:team_view',
  TEAM_CREATE_EDIT: 'user_management:team_create_edit',
  TEAM_DELETE: 'user_management:team_delete',
  ROLE_VIEW: 'user_management:role_view',
  ROLE_CREATE_EDIT: 'user_management:role_create_edit',
  ROLE_DELETE: 'user_management:role_delete',
  AUDIT_VIEW: 'user_management:audit_view',
  USER_PRODUCT_VIEW_LOG_VIEW: 'user_management:product_view_log_view',
  USER_NOTIFICATION_LOG_VIEW: 'user_management:notification_log_view',
  MOBILE_USER_MANAGEMENT_MANAGE: 'mobile_user_management:manage',
  WAREHOUSE_USERS_MANAGEMENT_VIEW: 'warehouse_users_management:view',
  WAREHOUSE_USERS_MANAGEMENT_INVENTORY_ADJUSTMENT:
    'warehouse_users_management:inventory_adjustment',
  WHOLESALE_CUSTOMER_VIEW: 'user_management:wholesale_customer_view',
  WHOLESALE_CUSTOMER_CREATE_EDIT: 'user_management:wholesale_customer_create_edit',
  WHOLESALE_CUSTOMER_DELETE: 'user_management:wholesale_customer_delete',

  // HR Management
  HR_DASHBOARD_VIEW: 'hr_management:dashboard_view',
  HR_EMPLOYEES_VIEW: 'hr_management:employees_view',
  HR_EMPLOYEES_CREATE_EDIT: 'hr_management:employees_create_edit',
  HR_EMPLOYEES_DELETE: 'hr_management:employees_delete',
  HR_EMPLOYEES_SALARY_VIEW: 'hr_management:employees_salary_view',
  HR_EMPLOYEES_MANAGE_ALL: 'hr_management:employees_manage_all',
  HR_ROSTER_VIEW: 'hr_management:roster_view',
  HR_ROSTER_CREATE_EDIT: 'hr_management:roster_create_edit',
  HR_ROSTER_CLOCK_CREATE_EDIT: 'hr_management:roster_clock_create_edit',
  HR_LEAVE_VIEW: 'hr_management:leave_view',
  HR_LEAVE_CREATE_EDIT: 'hr_management:leave_create_edit',
  HR_LEAVE_CANCEL: 'hr_management:leave_cancel',
  HR_SALARIES_VIEW: 'hr_management:salaries_view',
  HR_SALARIES_CREATE_EDIT: 'hr_management:salaries_create_edit',
  HR_SALARIES_MANAGE_ALL: 'hr_management:salaries_manage_all',
  HR_SALARY_VISIBILITY_VIEW: 'hr_management:salary_visibility_view',
  HR_ATTENDANCE_STATS_VIEW: 'hr_management:attendance_stats_view',
  HR_WORK_HOUR_ANOMALIES_VIEW: 'hr_management:work_hour_anomalies_view',
  HR_WORK_HOUR_ANOMALIES_MANAGE: 'hr_management:work_hour_anomalies_manage',
  HR_AUDIT_LOGS_VIEW: 'hr_management:audit_logs_view',

  // Franchise Management
  // Primary (matches backend/shared)
  FRANCHISEE_MANAGEMENT_ACCOUNT_VIEW: 'franchisee_management_accounts:account_view',
  // Legacy/aliases for backward compatibility
  FRANCHISEE_MANAGEMENT_ACCOUNT_VIEW_LEGACY: 'franchisee_management_accounts:view',
  FRANCHISEE_ACCOUNT_VIEW: 'franchisee:account_view',

  // Member Management
  MEMBER_VIEW: 'member:view',
  MEMBER_CREATE_EDIT: 'member:create_edit',
  MEMBER_DELETE: 'member:delete',
  MEMBER_EXPORT: 'member:export',
  MEMBER_VERIFICATION_VIEW: 'member_verification:view',
  MEMBER_CHALLENGE_VIEW: 'member_challenge:view',
  MEMBER_COUPON_VIEW: 'member_coupon:view',
  MEMBER_COUPON_CREATE_EDIT: 'member_coupon:create_edit',
  COUPON_TEMPLATE_VIEW: 'coupon_template:view',
  COUPON_TEMPLATE_CREATE_EDIT: 'coupon_template:create_edit',
} as const;

export type PermissionCode = (typeof PERMISSION_CODES)[keyof typeof PERMISSION_CODES];
